import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getSubscriptionRefundDataByTransactionId = async ({
  transactionId,
  refundType,
  refundAmount,
}: {
  transactionId: string;
  refundType: string;
  refundAmount?: number;
}) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      transactionId,
      refundType,
      refundAmount,
    },
    query: graphql(`
      query GetSubscriptionRefundDataByTransactionId($transactionId: String!, $refundType: String!, $refundAmount: Float) {
        getSubscriptionRefundDataByTransactionId(transactionId: $transactionId, refundType: $refundType, refundAmount: $refundAmount) {
          name
          refundAmount
          fullAmount
          refundDays
          totalPlanDays
          isCreditCharge
          transactionId
          isActiveSubscription
        }
      }
    `),
  });

  return response.data?.getSubscriptionRefundDataByTransactionId;
};
